const BgBluePanel = ({headerName}: {headerName: string}) => {
  return (
    <div className="jumbotron container-fluid text-white bg-blue">
      <div className="container">
        <div className="row">
          <h1 className="asH1">{headerName}</h1>
        </div>
      </div>
    </div>
  );
};

export default BgBluePanel;
